import { useHistory } from "react-router-dom";

import CustomerPage from "@/components/CustomerPage";
import CustomerTabs from "@/components/CustomerTabs";
import B2CHeader from "@/tpo/header/B2CHeader";

import { REPORTS_LIST_QUERY } from "./graphql/queries";
import ReportsGrid from "./reportList/ReportGrid";

export default function CustomerReports() {
  const history = useHistory();

  return (
    <>
      <B2CHeader />
      <CustomerPage
        bg="haze"
        includeFooter
        jumbotronProps={{
          title: "Reports"
        }}
      >
        <CustomerTabs selectedTab="/reports" />
        <ReportsGrid
          query={REPORTS_LIST_QUERY}
          listName="reports"
          onReportClick={userReport => history.push(`/reports/${userReport.slug}/overview`)}
        />
      </CustomerPage>
    </>
  );
}
